module.exports = __webpack_public_path__ + "static/header5-9809631b8f8e21dc196f40da213354cc.png";